import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import AppSiderMenu from 'components/AppSiderMenu';
import { StyledSider, SiderContent, StyledMenuButton } from './styles';

export interface AppSiderProps {
  isCollapsed?: boolean;
  onToggleMenu?: () => void;
}

const AppSider = ({
  isCollapsed = false,
  onToggleMenu,
}: AppSiderProps): JSX.Element => {
  return (
    <StyledSider collapsed={isCollapsed}>
      {onToggleMenu && (
        <StyledMenuButton onClick={onToggleMenu}>
          {isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </StyledMenuButton>
      )}
      <SiderContent>
        <AppSiderMenu />
      </SiderContent>
    </StyledSider>
  );
};

export default AppSider;
